import Cookies from 'js-cookie';

export const getValue = (prefix: string, key: string): string | undefined => {
  key = prefixedKey(prefix, key);
  return Cookies.get(key);
};

export const setValue = (prefix: string, key: string, value: string, expires?: number) => {
  key = prefixedKey(prefix, key);
  Cookies.set(key, value, { expires });
};

export const removeValue = (prefix: string, key: string) => {
  key = prefixedKey(prefix, key);
  Cookies.remove(key);
};

const prefixedKey = (prefix: string, key: string): string => `${prefix}_${key}`;
